<template>
  <card>
    <list
      v-if="$store.state.user.sections['banks']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: "col-12",
          label: "Лимит времени (токен)",
          key: "is_lifetime_token",
          type: "checkbox",
        },
        {
          col: "col-12 col-md-6",
          label: "Название",
          key: "name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Код",
          key: "code",
          type: "field",
        },

        {
          col: "col-12 col-md-6",
          label: "Логин",
          key: "api_login",
          type: "field",
        },

        {
          col: "col-12 col-md-6",
          label: "Пароль",
          key: "api_password",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "ENDPOINT URL",
          key: "api_endpoint_url",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Тип авторизации",
          key: "api_auth_type",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_bank",
      itemLink: "banks",
      setLink: "banks",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "code",
          title: "Ключ",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
